/**
 * El paginador de todas las tablas del admin (xcons-docs#499): arranca en 50 filas y ofrece
 * 50, 100, 200 y 300. Una sola definición para que ninguna tabla quede con las opciones viejas.
 */
export const FILAS_POR_PAGINA = 50;
export const OPCIONES_POR_PAGINA = [50, 100, 200, 300];
